import {BreadcrumbType, DataStatus} from 'platform/components';

// eslint-disable-next-line no-restricted-imports -- Intended
import {defaultTo, path, pipe} from 'ramda';

import {useGetCentralizedPricingQuery, usePostCentralizedPricingMutation} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsStackItemProps, SettingsStackItems, SettingsTemplate} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('page.salesSettingsBusinessCase.labels.businessCase'),
    href: settingsRoutes.businessCase,
  },
];

export function BusinessCaseCentralizedPricing() {
  const {data: centralizedPricing, isLoading, isError} = useGetCentralizedPricingQuery();
  const [updateCentralizedPricing] = usePostCentralizedPricingMutation();

  const value = pipe(path<boolean>([0, 'value']), defaultTo(false))(centralizedPricing);
  const onChange = (value: boolean) =>
    updateCentralizedPricing({value}).unwrap().catch(handleApiError);

  const items: SettingsStackItemProps[] = [
    {
      cyId: testIds.settings.businessCaseCentralizedPricing('allowCentralizedPricingProcess'),
      title: i18n.t('page.salesSettingsBusinessCase.labels.centralizedPricesProcess'),
      switchProps: {
        name: 'customerVerification-centralExecutionRecords',
        value,
        onChange,
      },
    },
  ];

  return (
    <SettingsTemplate
      header={{
        title: i18n.t('page.salesSettingsBusinessCase.labels.centralizedPricing'),
        breadcrumbs,
      }}
      data-testid={testIds.settings.businessCaseCentralizedPricing('settingsPage')}
    >
      <DataStatus isLoading={isLoading} isError={isError}>
        <SettingsStackItems items={items} />
      </DataStatus>
    </SettingsTemplate>
  );
}
